/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_SignersInputs */

const cs_tasks_protocol_signers = /** @type {(inputs: Tasks_Protocol_SignersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signatáři`)
};

const en_tasks_protocol_signers = /** @type {(inputs: Tasks_Protocol_SignersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signers`)
};

/**
* | output |
* | --- |
* | "Signers" |
*
* @param {Tasks_Protocol_SignersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_signers = /** @type {((inputs?: Tasks_Protocol_SignersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_SignersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_signers(inputs)
	return cs_tasks_protocol_signers(inputs)
});